"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const userInfo_1 = require("modules/user/userInfo");
const extensionsUserInfoStore_1 = __importDefault(require("./extensionsUserInfoStore"));
class ExtensionsUserInfoService {
    get extensionsUserInfo() {
        return (extensionsUserInfoStore_1.default && extensionsUserInfoStore_1.default.extensionsUserInfo);
    }
    async fetchExtensionsUserInfoData() {
        const userProfile = await userInfo_1.userInfoService.getProfile();
        if (!userProfile) {
            return;
        }
        const profile = {
            id: userProfile.id,
            email: userProfile.email,
            name: userProfile.name,
            attendant: userProfile.attendant,
            ucode: userProfile.ucode,
            extensions: userProfile.extensions,
            extensionsFreemium: userProfile.extensionsFreemium,
            isSurrogate: Boolean(userProfile.adminId)
        };
        extensionsUserInfoStore_1.default.profile = { ...profile };
    }
}
exports.default = new ExtensionsUserInfoService();
